export enum CompensationType {
Salaried,
DailySalaried,
ByContract,
NoPayment,
}
